// removed by extract-text-webpack-plugin
module.exports = {"button":"button--6f274","label":"label--4b077"};